import { render, staticRenderFns } from "./QuestionCardSection.vue?vue&type=template&id=a8f5a9b4&scoped=true"
import script from "./QuestionCardSection.vue?vue&type=script&lang=js"
export * from "./QuestionCardSection.vue?vue&type=script&lang=js"
import style0 from "./QuestionCardSection.vue?vue&type=style&index=0&id=a8f5a9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f5a9b4",
  null
  
)

export default component.exports